import React from 'react'
import BaseComponent from "../../pages/base/BaseComponent";
import PropTypes from "prop-types";
import {isEmpty} from "enqc-utilities/src/utils/Utilities";
import {Card, Col, Row} from "@themesberg/react-bootstrap";
import label from "enqc-utilities/src/label/Label";
import {faCode} from "@fortawesome/free-solid-svg-icons";
import TextInput from "../input/TextInput";

export default class RectifierControllerInformationCard extends BaseComponent{

    constructor(props) {
        super(props);
        let {assembly} = this.props
        if(isEmpty(assembly)){
            assembly = {}
        }
        this.setState({assembly})
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if(nextProps!=this.props){
            let {assembly} = nextProps
            if(isEmpty(assembly)){
                assembly = {}
            }
            this.setState({assembly})
        }
    }

    render() {
        let {assembly} = this.state
        if(isEmpty(assembly)){
            assembly = {}
        }
        let {rectifierControllerEntry} = assembly
        if(!rectifierControllerEntry){
            rectifierControllerEntry = {}
        }
        let {rectifierControllerSerialNumbers} = rectifierControllerEntry
        if(!rectifierControllerSerialNumbers){
            rectifierControllerSerialNumbers = []
        }
        return (
            <Card border="light" className="bg-white shadow-sm mb-4">
                <Card.Header>
                    {label.RectifierSerialNumber}
                </Card.Header>
                <Card.Body>
                    <Row>
                        {
                            rectifierControllerSerialNumbers.map((rectifierControllerSerialNumber, index)=>{
                                return (
                                    <Col key={index} xs={12} lg={6} className="text-left">
                                        <TextInput
                                            label={"#"+rectifierControllerSerialNumber.indexOrder}
                                            placeholder={" "}
                                            icon={faCode}
                                            readOnly={true}
                                            value={rectifierControllerSerialNumber.serialCode}
                                        />
                                    </Col>
                                )
                            })
                        }
                    </Row>
                </Card.Body>
            </Card>
        );
    }

}

RectifierControllerInformationCard.propTypes = {
    assembly : PropTypes.any,
}